import dayjs from 'dayjs';

/**
 * Parses date from API format to dayjs object
 * Handles both array format from Java LocalDateTime [year, month, day, hour, minute, second, nanoseconds]
 * and standard ISO string format
 * @param {Array|string} date - Date in array format or ISO string
 * @returns {dayjs.Dayjs} - Parsed dayjs object
 */
export const parseApiDate = (date) => {
  if (Array.isArray(date)) {
    // Java LocalDateTime array format: [year, month, day, hour, minute, second, nanoseconds]
    // Note: JavaScript Date month is 0-indexed, but Java month is 1-indexed
    const [year, month, day, hour = 0, minute = 0, second = 0, nanoseconds = 0] = date;
    return dayjs(new Date(year, month - 1, day, hour, minute, second, Math.floor(nanoseconds / 1000000)));
  }
  return dayjs(date);
};

/**
 * Formats API date to display format
 * @param {Array|string} date - Date in API format
 * @param {string} format - Display format (default: 'YYYY-MM-DD HH:mm')
 * @returns {string} - Formatted date string
 */
export const formatApiDate = (date, format = 'YYYY-MM-DD HH:mm') => {
  return parseApiDate(date).format(format);
};

/**
 * Compares two API dates for sorting
 * @param {Array|string} dateA - First date
 * @param {Array|string} dateB - Second date
 * @returns {number} - Comparison result for sorting
 */
export const compareApiDates = (dateA, dateB) => {
  const parsedA = parseApiDate(dateA);
  const parsedB = parseApiDate(dateB);
  return parsedA.valueOf() - parsedB.valueOf();
};